import { useMemo, useState } from "react";

// Input con suggerimenti predittivi presi dai valori già inseriti in precedenza (options).
export default function HistoryInput({ value, onChange, options = [], testId, className = "" }) {
  const [open, setOpen] = useState(false);
  const q = (value || "").trim().toLowerCase();
  const items = useMemo(() => {
    if (!q) return [];
    const seen = new Set();
    return options.filter((o) => {
      const k = (o || "").trim().toLowerCase();
      if (!k || k === q || seen.has(k) || !k.includes(q)) return false;
      seen.add(k);
      return true;
    }).sort((a, b) => a.toLowerCase().indexOf(q) - b.toLowerCase().indexOf(q)).slice(0, 8);
  }, [options, q]);
  return (
    <div className="relative">
      <input value={value || ""} onChange={(e) => { onChange(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)} data-testid={testId} autoComplete="off"
        className={`mt-1.5 h-9 w-full px-3 rounded-md bg-slate-900/60 border border-slate-700 text-sm text-slate-100 placeholder:text-slate-600 focus:outline-none focus:border-cyan-500/50 ${className}`} />
      {open && items.length > 0 && (
        <div className="absolute z-50 mt-1 w-full max-h-56 overflow-auto rounded-md border border-slate-700 bg-white shadow-lg" data-testid={`${testId}-suggestions`}>
          {items.map((o, i) => (
            <button key={o} type="button" onMouseDown={(e) => { e.preventDefault(); onChange(o); setOpen(false); }} data-testid={`${testId}-opt-${i}`}
              className="block w-full text-left px-3 py-1.5 text-sm text-slate-800 hover:bg-amber-100 transition-colors">{o}</button>
          ))}
        </div>
      )}
    </div>
  );
}
